import CampaignCardSkeleton from './CampaignCardSkeleton'

/**
 * Shimmer placeholder for the Home dashboard while campaigns + stats load.
 * Greeting header, an activity-stats strip, then the campaign card grid
 * (reuses CampaignCardSkeleton since Home's campaign cards share the same
 * horizontal layout as the Campaigns page).
 */
export default function HomeSkeleton() {
  return (
    <div style={{ margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 28 }}>
      {/* Greeting */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div className="skeleton" style={{ width: 260, height: 26, borderRadius: 6 }} />
        <div className="skeleton" style={{ width: 120, height: 14, borderRadius: 6 }} />
      </div>

      {/* Activity stats strip */}
      <div
        style={{
          background: 'var(--bg-primary)',
          border: '1px solid var(--border-primary)',
          borderRadius: 12,
          padding: 20,
          display: 'flex',
          gap: 40,
          flexWrap: 'wrap',
        }}
      >
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <div className="skeleton" style={{ width: 40, height: 20, borderRadius: 6 }} />
            <div className="skeleton" style={{ width: 110, height: 12, borderRadius: 6 }} />
          </div>
        ))}
      </div>

      {/* Campaigns section */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <div className="skeleton" style={{ width: 150, height: 18, borderRadius: 6 }} />
        <CampaignCardSkeleton count={3} />
      </div>
    </div>
  )
}
